import React from "react"
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Container from '@mui/material/Container';
import FootBar from "./foot-bar";
import NavBar from "./nav-bar"

const theme = createTheme({
    palette: {
      primary: {main:'#6b857c'},
      secondary: {main:'#d58756'},
      error:{main:'#f0a04b'},
      warning:{main:'#d58756'},
      info:{main:'#bb8f6a'},
      success:{main:'#92b57e'},
    },
    typography: {
      fontFamily: [
        'Lato',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      
    },
    spacing:8,
  });


const Layout = ({ children }) => (
  <ThemeProvider theme={theme}>
    <NavBar />
    <Container maxWidth="lg" sx={{ minHeight: '75vh' }}>
      {children}
    </Container>
    <FootBar />
  </ThemeProvider>
)


export default Layout
